import { Select } from '@automata/ui';
import { logger } from '@automata/utils';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { useMemo } from 'react';

import { BACKGROUND_DRIVER_NAMES } from '../../../constants';
import type { InstrumentForLocation } from '../../../types';
import { Icon } from '../../customIcons/instruments';

// import Chip from '../ChipWFB';

export type Props = {
  label: string;
  value: string | null;
  instruments: InstrumentForLocation[];
  onChange: (value: string | null) => void;
};

const NO_INSTRUMENT_SELECTED = 'NO_INSTRUMENT_SELECTED';

export const InstrumentSelect = ({
  label,
  value,
  onChange,
  instruments,
}: Props): JSX.Element => {
  const filteredInstruments = useMemo(
    () =>
      instruments.filter(
        ({ driverName }) => !BACKGROUND_DRIVER_NAMES.includes(driverName)
      ),
    [instruments]
  );

  return (
    <FormControl fullWidth>
      <Select
        label={label}
        value={value === null ? NO_INSTRUMENT_SELECTED : value}
        onChange={(e) => {
          const value = e.target.value;
          if (value === null || typeof value === 'string') {
            onChange(value);
          } else {
            logger.error('ContentField: unexpected value type for:', value);
          }
        }}
      >
        {/* Special menu item for case where it's null */}
        {value === null && (
          <MenuItem value={NO_INSTRUMENT_SELECTED} disabled>
            <Typography fontStyle="italic">(No instrument selected)</Typography>
          </MenuItem>
        )}
        {filteredInstruments.map(({ id, driverName, name }) => (
          <MenuItem key={id} value={id}>
            <Stack direction="row" gap={1}>
              <Icon iconType={driverName} fontSize="small" />
              <Stack flex="2" justifyContent="center">
                <Typography variant="body2" lineHeight="unset">
                  {name}
                </Typography>
              </Stack>
              {/*
                <Stack
                  direction="row"
                  flex="2 1 auto"
                  flexWrap="wrap"
                  justifyContent="right"
                  gap="0.1rem"
                > */}
              {/* TODO(IL, 2024-04-04): removed because desired behavior is TBD. If we don't use instrument.capabilities, remove it. */}
              {/* {instrument.capabilities.map((capability) => (
                    <Chip key={capability} label={capability} />
                  ))}
                </Stack> */}
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
